import store from "@/store/store";
import { Axios } from "@/services/_axios";

async function getPersonalOfficeMessages(lang) {
  let messages = [];
  if (globalThis.SERVER_MODE != "offline") messages = [];
  else {
    try {
      const version = store.state.user.licenseInfo.otzarVer || 0;
      let url = `/api/general/officeMessageFromTablet?id=${
        globalThis.OTZAR_BASIC_INFO.userId
      }&version=${version}&mode=offline&lang=${lang || "he"}`;

      const message = await Axios.get(url);
      if (typeof message.data == "string") {
        messages = [];
      } else {
        if (message.data[0]) {
          message.data = message.data.filter((m) => m.data);

          message.data.forEach((d) => {
            d.data = prepareHtml(d.data);
          });
          messages = message.data;
        } else messages = [];
      }
    } catch (ex) {
      console.log(`Error getting office messages >> ${ex.message}`);
      messages = [];
    }
  }
  return messages;
}

async function setMessageRead(msgId) {
  let url = `/api/general/officeMessageReadTablet`;

  let data = { msgIds: [msgId] };
  const message = await Axios.post(url, data, { timeout: 1000 });
}

function prepareHtml(txt) {
  return txt.replace(/window.open\(/g, "window.openHref(");
}

export { getPersonalOfficeMessages, setMessageRead };
